import React, { useState } from 'react';
import cx from 'classnames';
import StatusTooltip from './StatusTooltip/index.js';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as GirdedCheck } from 'assets/icons/girded-check.svg';
import { ReactComponent as GirdedExclamation } from 'assets/icons/girded-exclamation.svg';

const TaskStatus = ({ status, id, className }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localStatus, setLocalStatus] = useState(status);

  const statusIconsOptions = {
    NOT_ATTENDED: <div />,
    KEEP_AN_EYE: <EyeIcon data-testid="keepAnEyeStatus" />,
    review: <EyeIcon />,
    solve: <GirdedCheck />,
    pending: <GirdedExclamation />,
  };
  const StatusIcon = statusIconsOptions[localStatus] ? statusIconsOptions[localStatus] : <div />;

  return (
    <>
      {!loading && (
        <StatusTooltip
          taskId={id}
          setLocalStatus={setLocalStatus}
          setTooltipOpen={setTooltipOpen}
          status={status}
          setLoading={setLoading}
        />
      )}
      <div className={className} data-tip data-for={`${id}-tooltip`}>
        <div
          className={cx('circle', {
            'circle--status-pending': tooltipOpen && localStatus === 'NOT_ATTENDED',
            'circle--status-keep-an-eye': tooltipOpen && localStatus === 'KEEP_AN_EYE',
            'circle--status-loading': loading,
          })}
        >
          {StatusIcon}
        </div>
      </div>
    </>
  );
};

export default TaskStatus;
